// extracted by mini-css-extract-plugin
export var active = "modal-module--active--ba06c";
export var content = "modal-module--content--d80d0";
export var modal = "modal-module--modal--afbc3";
export var overlay = "modal-module--overlay--5e7b2";
export var slide = "modal-module--slide--cdd91";